export default "__VITE_ASSET__Z7fbxfUO__"